import * as React from "react";

import I18n, { TranslationsObjectKeys } from "lib/I18n";
import { convertBytesToReadable } from "lib/converter";

import moment from "moment";
import { QueryLog } from "../../store";

const maxSummaryLength = 80;

interface QueryCellProps {
  query: string;
}

function QueryCell(props: QueryCellProps) {
  const { query } = props;

  if (query.length < maxSummaryLength) {
    return query;
  }
  return (
    <details>
      <summary>{query.substr(0, maxSummaryLength)}...</summary>
      {query}
    </details>
  );
}

interface TableProps {
  logs: QueryLog[];
}

export function Table(props: TableProps) {
  const { logs } = props;

  return (
    <table className="table tabpe-striped">
      <thead>
        <tr>
          <th className="nn-nowrap">
            {I18n.t(`bigquery_history_viewer.label.user`)}
          </th>
          <th className="nn-nowrap">
            {I18n.t(`bigquery_history_viewer.label.state`)}
          </th>
          <th className="nn-nowrap">
            {I18n.t(`bigquery_history_viewer.label.context`)}
          </th>
          <th className="nn-nowrap">
            {I18n.t(`bigquery_history_viewer.label.cost`)}
          </th>
          <th className="nn-nowrap">
            {I18n.t(`bigquery_history_viewer.label.data_scanned_in_bytes`)}
          </th>
          <th className="nn-nowrap">
            {I18n.t(`bigquery_history_viewer.label.execution_time`)}
          </th>
          <th className="nn-nowrap">
            {I18n.t(`bigquery_history_viewer.label.created_at`)}
          </th>
          <th className="nn-nowrap">
            {I18n.t(`bigquery_history_viewer.label.query`)}
          </th>
        </tr>
      </thead>
      <tbody>
        {logs.map((log, i) => {
          return (
            <tr key={i}>
              <td className="nn-nowrap">{log.user_name}</td>
              <td className="nn-nowrap">{log.state}</td>
              <td className="nn-nowrap">
                {I18n.t(
                  `bigquery_history_viewer.context.${log.context}` as TranslationsObjectKeys,
                )}
              </td>
              <td className="nn-nowrap">{log.cost.toPrecision(3)}</td>
              <td className="nn-nowrap">
                {log.data_scanned_in_bytes
                  ? convertBytesToReadable(log.data_scanned_in_bytes)
                  : ""}
              </td>
              <td className="nn-nowrap">{log.execution_time}</td>
              <td className="nn-nowrap">
                {moment(log.created_at).format("YYYY-MM-DD HH:mm:ss ZZ")}
              </td>
              <td className="nn-break-word">
                <QueryCell query={log.query} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
